/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Page_TitleInputs */

const en_samples_page_title = /** @type {(inputs: Samples_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample Requests`)
};

const es_samples_page_title = /** @type {(inputs: Samples_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitudes de muestras`)
};

/**
* | output |
* | --- |
* | "Sample Requests" |
*
* @param {Samples_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_page_title = /** @type {((inputs?: Samples_Page_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Page_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_page_title(inputs)
	return es_samples_page_title(inputs)
});